import { Button } from '@/components/UI/Button'
import { Dialog } from '@/components/UI/Dialog'
import dialogStyles from '@/components/UI/Dialog.module.css'
import { Image } from '@/components/UI/Image'
import { Switch } from '@/components/UI/Switch'
import { useTranslation } from 'react-i18next'

type FrameItem = {
  index: number
  label: string
  thumbnailUrl: string
  visible: boolean
}

type FrameSettingsDialogProps = {
  open: boolean
  onClose: () => void
  frames: FrameItem[]
  onToggleFrame: (index: number, visible: boolean) => void
  onReset: () => void
}

export const FrameSettingsDialog = ({ open, onClose, frames, onToggleFrame, onReset }: FrameSettingsDialogProps) => {
  const { t } = useTranslation()

  return (
    <Dialog
      selectorState={open}
      closeFunc={onClose}
      showCloseButton
      title={t('spot_detail.ar.frame_settings_title', 'ARフォトフレームの設定')}
    >
      <div className="flex flex-col items-center">
        {/* 説明 */}
        <p className="text-[12px] text-black text-center leading-[16px]">
          {t('spot_detail.ar.frame_settings_description', '画像の表示/非表示とリセットが行えます')}
        </p>

        {/* フレームリスト。
            scrollArea が Dialog body の padding を打ち消し、スクロールバーをダイアログ端に寄せる。
            w-full ではなく self-stretch を使うこと。親が items-center のため w-full だと
            margin-box が中央寄せされ、scrollArea の負マージンが打ち消される */}
        {frames.length > 0 && (
          <div className={`${dialogStyles.scrollArea} self-stretch mt-6 max-h-[50vh]`}>
            <div className="flex flex-col gap-4">
              {frames.map((frame) => (
                <div key={frame.index} className="flex items-start justify-between w-full">
                  <span className="font-bold text-[16px] text-black leading-[24px]">{frame.label}</span>
                  <div className="flex items-start gap-3">
                    <div className="w-[100px] overflow-hidden rounded bg-[#d9d9d9]">
                      <Image src={frame.thumbnailUrl} alt={frame.label} fit="width-fit" />
                    </div>
                    <Switch
                      checked={frame.visible}
                      onChange={(checked) => onToggleFrame(frame.index, checked)}
                      color="var(--main-color)"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ボタン */}
        <div className="mt-6 flex items-center justify-center gap-2 w-full">
          <Button
            label={t('spot_detail.ar.back_to_camera', '戻る')}
            variant="system-back"
            size="md"
            onClick={onClose}
            fullWidth
          />
          <Button
            label={t('spot_detail.ar.frame_reset', 'リセットする')}
            variant="danger"
            size="md"
            onClick={() => {
              onReset()
            }}
            fullWidth
          />
        </div>
      </div>
    </Dialog>
  )
}
